import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    position: 'fixed',
    bottom: 0,
    left: 0,
    boxShadow: '0 -2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
    width: '100%',
    backgroundColor: theme.colors.page__background_primary,
    zIndex: 100
  },
  footerInner: {
    width: '100%',
    maxWidth: theme.screens.standard_desktop,
    margin: '0 auto',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(6, 8)
  },
  leftBlock: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(4)
  },
  draftIcon: {
    width: 40,
    height: 40,
    flexShrink: 0
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  buttons: {
    display: 'flex',
    gap: theme.spacing(3),
    flexShrink: 0
  },
  btn: {
    maxWidth: 350,
    padding: theme.spacing(0, 4)
  },
  viewNotesBtn: {
    backgroundColor: theme.colorPalette.orange_50,
    '&:hover': {
      backgroundColor: theme.colorPalette.orange_75
    }
  },
  btnLabel: {
    fontWeight: 500,
    fontSize: 16,
    color: theme.colors.white
  },
  headingTitle: {
    lineHeight: 1.33
  },
  headingDetail: {
    fontStyle: 'italic'
  },
  bottomBar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: 36,
    fontSize: 14,
    padding: theme.spacing(2)
  },
  orange: {
    backgroundColor: theme.colorPalette.orange_50,
    color: theme.colorPalette.white
  },
  beige: {
    backgroundColor: theme.colorPalette.beige_60,
    color: theme.colorPalette.green_90
  },
  bottomBarIcon: {
    height: 14,
    marginRight: theme.spacing(1),
    transform: 'rotate(180deg)'
  },
  link: {
    color: 'inherit',
    display: 'inline-block',
    marginLeft: theme.spacing(1),
    textDecoration: 'underline'
  }
});

export default makeStyles(styles);
